import { combineReducers } from "redux";

import visits from "../features/VisitsSlice";

const rootReducer = combineReducers({
  visits,
});

const configureRootReducer = (state, action) => rootReducer(state, action);

export default configureRootReducer;
